<h5>CNAEs Impedidos de Operar</h5>

<section class="pesquisa">
  <div class="container">
    <form class="mt-3 mx-auto">
      <div class="mb-3 row">
        <div class="col">
          <h3>Pesquisa</h3>
        </div>
        <div class="col-auto" *ngIf="podeCadastrar">
          <button class="btn btn-primary no-margin" type="button" [disabled]="!ideTranche"
          (click)="abrirModal('Modal com body sendo uma template', 'lg form-label', true, true);">
            Cadastrar Nova Máscara CNAE</button>
        </div>
        <div class="col-auto">
          <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
        </div>
        <div class="col-auto" *ngIf="ideTranche == null; else podePesquisar">
          <button disabled type="button" class="btn btn-success no-margin">
          Pesquisar</button>
        </div>
        <ng-template #podePesquisar>
          <div class="col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="buscarTodos()">
            Pesquisar</button>
          </div>
        </ng-template>
      </div>
    </form>

    <div class="bn-form-group row" id="form-group-check">
        <div class="col-md-6">
          <label for="tranche">Cesta: </label>
          <select id="tranche" class="form-select" [(ngModel)]="ideTranche">
            <option [ngValue]=null></option>
            <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
              {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
          </select>
        </div>
    </div>

    <div class="mb-3 row" id="form-group-check2">
        <div class="col-md-3">
          <bn-datepicker style="display: none;" *ngIf="ideTranche == null; else podePesquisarDataInicio"
              name="dataInicio"
              idInput="dataInicio"
              ngDefaultControl
              [(ngModel)]="dataInicio">
          </bn-datepicker>
          <ng-template #podePesquisarDataInicio>
            <label>Data Início Validade:</label>
            <bn-datepicker
                name="dataInicio"
                idInput="dataInicio"
                ngDefaultControl
                [(ngModel)]="dataInicio">
            </bn-datepicker>
          </ng-template>
        </div>
  
        <div class="col-md-3">
            <bn-datepicker style="display: none;" *ngIf="ideTranche == null; else podePesquisarDataFim"
                name="dataFim"
                idInput="dataFim"
                ngDefaultControl
                [(ngModel)]="dataFim">
            </bn-datepicker>
            <ng-template #podePesquisarDataFim>
              <label>Data Fim Validade:</label>
              <bn-datepicker
                  name="dataFim"
                  idInput="dataFim"
                  ngDefaultControl
                  [(ngModel)]="dataFim">
              </bn-datepicker>
            </ng-template>
        </div>

        <div class="col-md-3">
          <select id="tipoOperacao" class="form-select" [(ngModel)]="tipoOperacao" style="display: none;" *ngIf="ideTranche == null; else podePesquisarTipo">
            <option [ngValue]="undefined" selected>Todos</option>
          </select>
          <ng-template #podePesquisarTipo>
            <label for="tipoOperacao">Tipo da Operação: </label>
            <select id="tipoOperacao" class="form-select" [(ngModel)]="tipoOperacao">
              <option [ngValue]="undefined" selected>Todos</option>
              <option [value]="item.valor" *ngFor="let item of tiposOperacoes">
                {{item.nome}}
              </option>
            </select>
          </ng-template>
        </div>

        <div class="col-md-3">
          <select id="situacao" class="form-select" [(ngModel)]="situacao" style="display: none;" *ngIf="ideTranche == null; else podePesquisarSituacao">
            <option [ngValue]="undefined" selected>Todos</option>
            <option [ngValue]="1">Ativos</option>
            <option [ngValue]="0">Inativos</option>
          </select>
          <ng-template #podePesquisarSituacao>
            <label for="situacao">Situação: </label> <i class="fa fa-question-circle help-subtitulo"
            placement="bottom"
            ngbTooltip="Exibe a situação da Validade do Impedimento do Agente Financeiro"></i>
            <select id="situacao" class="form-select" [(ngModel)]="situacao">
              <option [ngValue]="undefined" selected>Todos</option>
              <option [value]="item.valor" *ngFor="let item of situacoes">
                {{item.nome}}
              </option>
            </select>
          </ng-template>
        </div>
        
    </div>
  </div>
  </section>

  <ng-template #body>
    <div class="container">
      <div class="row">
        <div class="col">
        </div>
      </div>
      <div class="row">
          <div class="bn-form-group col-auto">
            <label><b>Máscara</b></label>
            <input class="form-control" id="mascara" [(ngModel)]="mascara" maxlength="8" required/>
          </div>

          <div class="bn-form-group col-auto">
            <label><b>Início da validade de impedimento</b></label>
            <input type="date" class="form-control" id="dataInicioValidadeImpedimento" [(ngModel)]="dataInicioValidadeImpedimento" required/>
          </div>

          <div class="bn-form-group col-auto">
            <label><b>Tipo da operação</b></label>
            <select id="codigoTipoOperacao" class="form-select" [(ngModel)]="codigoTipoOperacao">
                    <option [ngValue]="null"></option>
                    <option [ngValue]="item.codigo" *ngFor="let item of labelsOperacao">
                        {{item.codigo}} - {{item.nome}}
                    </option>
                  </select>
          </div>

          <div class="bn-form-group col-md-6">
            <label><b>Objetivo do Financiamento</b></label>
            <select id="codigoModalidadeOperacao" class="form-select" [(ngModel)]="codigoModalidadeOperacao">
                    <option [ngValue]="null"></option>
                    <option [ngValue]="item.codigo" *ngFor="let item of objetivosFinanciamento">
                        {{item.codigo}} - {{item.nome}}
                    </option>
                  </select>
          </div>
      </div>

      <div *ngIf="mensagemAviso" class="alert alert-warning">
        {{mensagemAviso}}
      </div>
      
    </div>
  </ng-template>

  <ng-template #botoes>
    <button class="btn btn-danger" (click)="close()">Fechar</button>
    <button class="btn btn-success" (click)="salvar()">Salvar</button>
  </ng-template>
  

  <app-cnae-impedido-listagem
    [cnaeImpedido]="cnaeImpedido" [filtroCnaeImpedido]="filtroCnaeImpedido" [permissaoEdicao]="permissaoEdicao" 
    [atributosPaginacao]="atributosPaginacaoComponenteListagem"
    (aoMudarPagina)="mudancaPagina($event)"
    (exportarCnaes)="exportarCnaes()"
    *ngIf="pesquisado"
    [hidden]="esconderPesquisa">
  </app-cnae-impedido-listagem>


